var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import styled from "styled-components";
import { HomePageWidgetTypes } from "@irati/types";
import { getOrderedMobileTiles } from "@irati/tenant-metadata/helpers";
import Image from "./widgets/Image";
import ImageWithText from "./widgets/ImageWithText";
import Video from "./widgets/Video";
import WrongType from "./widgets/WrongType";
var MobileTileWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: calc(100vw - 30px);\n  height: ", ";\n  margin-bottom: 15px;\n"], ["\n  width: calc(100vw - 30px);\n  height: ", ";\n  margin-bottom: 15px;\n"])), function (props) { return "calc((100vw/(" + props.width + "/" + props.height + ")) - 30px)"; });
var Mobile = /** @class */ (function (_super) {
    __extends(Mobile, _super);
    function Mobile() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Mobile.prototype.render = function () {
        var tiles = this.props.tiles;
        var mobileWidgets = getOrderedMobileTiles(tiles);
        var onClick = this.props.onClick;
        return (React.createElement(React.Fragment, null, mobileWidgets.map(function (tile) {
            var id = tile.id, width = tile.width, height = tile.height, type = tile.type;
            var _a = tile[type], image = _a.image, link = _a.link, body = _a.body, header = _a.header, videoUrl = _a.videoUrl;
            switch (type) {
                case HomePageWidgetTypes.Image:
                    return (React.createElement(MobileTileWrapper, { key: id, width: width, height: height },
                        React.createElement(Image, { image: image, link: link, onClick: onClick })));
                case HomePageWidgetTypes.ImageWithText:
                    return (React.createElement(MobileTileWrapper, { key: id, width: width, height: height },
                        React.createElement(ImageWithText, { image: image, body: body, header: header, link: link, onClick: onClick })));
                case HomePageWidgetTypes.Video:
                    return (React.createElement(MobileTileWrapper, { key: id, width: width, height: height },
                        React.createElement(Video, { onClick: onClick, videoUrl: videoUrl })));
                default:
                    return (React.createElement(MobileTileWrapper, { key: id },
                        React.createElement(WrongType, null)));
            }
        })));
    };
    return Mobile;
}(Component));
export default Mobile;
var templateObject_1;
